import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueObject, Result, BadInputError } from '@digibricks/domains';
export var ConversationTitle = /*#__PURE__*/function (_ValueObject) {
  _inherits(ConversationTitle, _ValueObject);

  var _super = _createSuper(ConversationTitle);

  function ConversationTitle() {
    _classCallCheck(this, ConversationTitle);

    return _super.apply(this, arguments);
  }

  _createClass(ConversationTitle, [{
    key: "value",
    get: function get() {
      return this.props;
    }
  }], [{
    key: "isValid",
    value: function isValid(title) {
      return title.length >= this.minLength && title.length <= this.maxLength && title.trim().length > 0;
    }
  }, {
    key: "create",
    value: function create(title) {
      if (!this.isValid(title)) {
        return new BadInputError("Title must be between ".concat(this.minLength, " and ").concat(this.maxLength, " characters"));
      }

      return Result.ok(new ConversationTitle(title.trim()));
    }
  }]);

  return ConversationTitle;
}(ValueObject);

_defineProperty(ConversationTitle, "maxLength", 200);

_defineProperty(ConversationTitle, "minLength", 1);

_defineProperty(ConversationTitle, "default", ConversationTitle.create('Untitled').getValue());